import { login as expertUserLoginAPI } from 'api/v2/experts/authentication';
import { login as webUserLoginAPI } from 'api/v2/users/authentication';
import type { AxiosError } from 'axios';
import { product } from 'config';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import type { IAPILoginBody } from 'types/auth.types';
import useGetOnUserLogin from './useGetOnUserLogin';

const login = product === 'web' ? webUserLoginAPI : expertUserLoginAPI;

const useLogin: any = (target: string) => {
  const navigate = useNavigate();

  const onLogin = useGetOnUserLogin(target);
  return useMutation((data: IAPILoginBody) => login(data), {
    onSuccess: (data) => onLogin(data),
    onError: (
      error: AxiosError<{ type: 'mfa_required'; factors: { totp: boolean } }>,
      data,
    ) => {
      const { email, password, googleIdToken, appleIdToken } = data;

      if (error.isAxiosError && error.response?.data?.type == 'mfa_required') {
        if (error.response.data.factors.totp)
          navigate('/login/totp', {
            state: { email, password, googleIdToken, appleIdToken },
          });
      }
    },
  });
};

export default useLogin;
